export const passwordValidation = (passwordValues, validationData) => {
  if (passwordValues.newPassword?.length < 8) {
    validationData["newPassword"] = "Passwort zu kurz";
  } else {
    delete validationData["newPassword"];
  }

  if (passwordValues.newPassword !== passwordValues.confirmPassword) {
    validationData["confirmPassword"] = "Passwort stimmt nicht überein";
  } else {
    delete validationData["confirmPassword"];
  }

  return validationData;
};
